import React, { Component } from 'react';
import './Item.css'
import SWTCarEditModal from '../../workdoc/SWTCarEditModal'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    this.refs.newCustomerPop.openPopup()
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.settings.show&&newProps.settings.show!==this.props.settings.show) {
  //     this.refs.newCustomerPop.getWrappedInstance().openPopup()
  //   }
  // }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['Car Config']}</h3>
        <SWTCarEditModal 
          mode='table'
          ref={'newCustomerPop'}
          onHide={()=>{}}
        />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu8.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu8/Item.js